import React, {useEffect, useState} from "react";
import figure2 from "../../../../assets/images/figure2.png";
import figure3 from "../../../../assets/images/figure3.png";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import figure5 from "../../../../assets/images/figure5.png";
import figure8 from "../../../../assets/images/figure8.png";
import figure9 from "../../../../assets/images/figure9.jpg";
import figure10 from "../../../../assets/images/figure10.jpg";
import figure6 from "../../../../assets/images/figure6.jpg";
import figure7 from "../../../../assets/images/figure7.png";
import figure13 from "../../../../assets/images/figure13.png";
import figure15 from "../../../../assets/images/figure15.png";
import figure16 from "../../../../assets/images/figure16.png";
import BlogImagePopper from "./BlogImageLarge";
const Blog7 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">
          Weekly Market Outlook <br /> February 24, 2025
        </h2>
      </div>
      <div className="blogContentnew">
        <div className="subHeader">
          <p className="highlightedBoldText">Setting the Stage: Markets on Edge Ahead of a Big Week</p>
          <p>
            Volatility is creeping back in, and traders are gearing up for what could be a pivotal week. After retail sales disappointed and Walmart confirmed a bleak 2025 outlook, sentiment took a
            hit. Friday’s Michigan Consumer Sentiment collapse, alongside weak global PMIs, tipped the scales toward risk-off. The broader macro environment remains uncertain, with geopolitical
            tensions simmering under the surface and bond market volatility suggesting an impending shift in risk appetite.
          </p>
          <p>
            Bond volatility is stirring, with MOVE and VIX ticking up—watch for Put/Call parity nearing 1. Meanwhile, geopolitical risks remain in the background, though Ukraine's push for a European
            peace envoy and OPEC+ supply maneuvers could quickly shift the narrative. Energy markets are closely watching developments in uranium supply talks, particularly between the US and
            Australia, which could impact nuclear power investments.
          </p>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader pointersWrapper">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <h2 className="highlightedBoldText">Key Market Themes</h2>
              <div className="contentInnerWrapper">
                <div className="themesPointer pointersSection">
                  <h2 className="pointersText">1.Bond Volatility & Yields: Buckle Up</h2>
                  <p>
                    Scott Bessent’s strategy of short-term bill financing persists, but the Trump team is eyeing longer-term yield normalization. Despite headline noise, bond volatility wasn’t
                    initially breaking out—until Friday changed the game. US 10Y yields are erratic, dangerously flirting with slower growth pricing, which is causing concern about a potential
                    economic slowdown. Stagflation chatter is picking up, adding to uncertainty over how central banks will respond.
                  </p>
                </div>
                <div className="imageWrapper">
                  <div className="relatedImg">
                    <img
                      src={figure2}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => setSelectedImage(figure2)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={figure3}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => setSelectedImage(figure3)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contentInnerWrapper flexDiv">
                <div className="themesPointer pointersSection">
                  <h2 className="pointersText">2.Equities: Fence-Sitting Mode</h2>
                  <p>
                    Equity market rotations are widening—50% of sectors up vs. just 25% in recent years—but without a real selloff yet. The Russell 2000 is breaking down, putting markets on a knife
                    edge. A final push higher is possible, but a selloff looms large. With Nvidia’s earnings (Wednesday) and CB Consumer Confidence (Tuesday) on deck, traders should prepare for a
                    sharp directional move. The broader tech sector remains under pressure, especially with China’s continued focus on semiconductor competition and AI advancements.
                  </p>
                </div>
                <div className="imageWrapper">
                  <div className="relatedImg">
                    <img
                      src={figure5}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => setSelectedImage(figure5)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contentInnerWrapper">
                <div className="themesPointer pointersSection">
                  <h2 className="pointersText">3.China Tech & Global Investment Flows</h2>
                  <p>
                    China’s tech sector is outperforming, but valuations remain depressed compared to US peers. Investment flows are shifting—though it’s too early to call it a structural move away
                    from US markets. Tariff concerns remain a wildcard, with March deadlines approaching for key trade policies that could impact global supply chains. The weaker yuan is also playing
                    a role in attracting capital to Chinese markets, as investors seek higher relative growth rates
                  </p>
                </div>
              </div>

              <div className="contentInnerWrapper">
                <div className="themesPointer pointersSection">
                  <h2 className="pointersText">4.Gold: ATHs & Market Dislocations</h2>
                  <p>
                    Gold has hit new all-time highs, fueled by physical delivery demands and central bank buying. Futures spreads are flashing warning signals of arbitrage opportunities driven by
                    shortages. With the March-April tariff decision looming, gold’s role as a safe haven remains solid, but price action could be volatile if supply chain pressures ease. The widening
                    spread between futures and spot prices suggests continued stress in the market, with delivery constraints adding fuel to the rally.
                  </p>
                </div>
                <div className="imageWrapper">
                  <div className="relatedImg">
                    <img
                      src={figure8}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => setSelectedImage(figure8)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={figure9}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => setSelectedImage(figure9)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={figure10}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => setSelectedImage(figure10)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <h2 className="highlightedBoldText">Technical & Sentiment Analysis</h2>
              <div className="listOfRecap">
                <ul>
                  <li>
                    <span className="highlightedText">Bond markets</span>Volatility is finally showing signs of life, confirming Friday’s breakout. The lack of clarity on Fed policy remains a major
                    overhang.
                  </li>

                  <li>
                    <span className="highlightedText">Equities</span> : Sentiment is at a coin flip—market structure suggests either a final push higher or a fast drop. Increased hedging activity
                    among institutional players suggests caution.
                  </li>
                  <li>
                    <span className="highlightedText">Commodities</span> :Oil traders skeptical on OPEC+ supply delays; gold remains bid on geopolitical tensions and delivery constraints.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <div className="contentDivWrapper flexImg ">
            <div className="contentDiv">
              <h2 className="highlightedBoldText">Last Week’s Recap: Key Events & Earnings</h2>
              <div className="listOfRecap">
                <ul>
                  <li>
                    <span className="highlightedText">Bond markets</span>Volatility is finally showing signs of life, confirming Friday’s breakout. The lack of clarity on Fed policy remains a major
                    overhang.
                  </li>

                  <li>
                    <span className="highlightedText">Equities</span> : Sentiment is at a coin flip—market structure suggests either a final push higher or a fast drop. Increased hedging activity
                    among institutional players suggests caution.
                  </li>
                  <li>
                    <span className="highlightedText">Commodities</span> :Oil traders skeptical on OPEC+ supply delays; gold remains bid on geopolitical tensions and delivery constraints.
                  </li>
                </ul>
              </div>
            </div>
            <div className="imageWrapper">
              <div className="relatedImg">
                <img
                  src={figure6}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => setSelectedImage(figure6)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={figure7}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => setSelectedImage(figure7)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <div className="contentDivWrapper rowReverse ">
            <div className="contentDiv">
              <h2 className="highlightedBoldText">The Week Ahead: Key Market Events</h2>
              <div className="listOfRecap">
                <ul>
                  <li>
                    <span className="highlightedText">Tuesday</span>: CB Consumer Confidence – Can it recover after the Michigan collapse?
                  </li>

                  <li>
                    <span className="highlightedText"> Wednesday: Nvidia Earnings</span> : – A potential market mover, especially after recent weakness. AI-related spending will be a key focal point.
                  </li>
                  <li>
                    <span className="highlightedText">Thursday</span>: US GDP Q4 (2nd read) & Durable Goods – Key data on economic momentum. Industrial production figures will provide insight into
                    manufacturing resilience
                  </li>
                  <li>
                    <span className="highlightedText"> Friday: PCE Inflation Data –</span> The Fed’s preferred inflation gauge, critical for rate expectations. The Fed’s next move could be influenced
                    by this data point.
                  </li>
                </ul>
              </div>
            </div>
            <div className="imageWrapper">
              <div className="relatedImg">
                <img
                  src={figure13}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => setSelectedImage(figure13)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <div className="contentDivWrapper ">
            <div className="contentDiv">
              <h2 className="highlightedBoldText">Actionable Takeaways</h2>
              <div className="listOfRecap">
                <ul>
                  <li>
                    <span className="highlightedText">Volatility is back</span>– Traders should watch VIX and MOVE; bond volatility is now in play, and liquidity remains thin
                  </li>

                  <li>
                    <span className="highlightedText">Equity markets are at an inflection point</span>– Nvidia earnings could determine short-term direction, with semiconductors and AI stocks under
                    scrutiny.
                  </li>
                  <li>
                    <span className="highlightedText"> Gold is flashing warning signs </span> – Physical delivery stress and futures spreads suggest ongoing market dislocations, but speculative flows
                    could exaggerate moves.
                  </li>
                  <li>
                    <span className="highlightedText"> . Watch the Consumer</span> – Confidence data is shaky, and Friday’s PCE will be critical for rate expectations. Wage growth data could provide
                    additional clues.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader ">
          <div className="contentDivWrapper ">
            <div className="contentDiv">
              <h2 className="highlightedBoldText">Key Trades to Watch</h2>
              <div className="listOfRecap">
                <ul>
                  <li>
                    <span className="highlightedText"> Long volatility</span>: MOVE & VIX positioning suggests a breakout setup. Consider structured option plays.
                  </li>

                  <li>
                    <span className="highlightedText">Short Russell 2000</span>: Small caps breaking down could be the first real sign of equity weakness. Look for key support levels.
                  </li>
                  <li>
                    <span className="highlightedText">Gold spreads </span> : Dislocations present arbitrage opportunities, but the risk of mean reversion remains.
                  </li>
                  <li>
                    <span className="highlightedText"> Watch bond market reaction to PCE</span> – : A stronger-than-expected print could push yields higher, impacting risk assets.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader ">
          <div className="contentDivWrapper ">
            <div className="contentDiv">
              <h2 className="highlightedText">Markets are primed for a pivotal week—stay sharp and position accordingly.</h2>
              <div className="imageWrapper">
                <div className="relatedImg">
                  <img
                    src={figure15}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => setSelectedImage(figure15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={figure16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => setSelectedImage(figure16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </div>
  );
};

export default Blog7;
